export default __webpack_public_path__ + "static/33-9789caee6080e6c1dd1d4588ae8d65e2.jpg";